//
//
//
//
//
//
//
//
//
//

import { Work } from '@/models'
import BottomBar from './BottomBar.vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    work: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      liked: false
    }
  },

  created () {
    if (this.user) {
      if (this.work) {
        Work.checkLike(this.work.id).then(liked => this.liked = liked)
      } else {
        console.error('work is not exist')
      }
    } else {
      console.error('uesr is not exist')
    }
  },

  computed: {
    ...mapGetters(['user'])
  },

  methods: {
    toggleLike (likedStatus) {
      let id = this.work.id

      ;(likedStatus ? Work.unlike(id) : Work.like(id))
        .then(succeed => {
          if (succeed) {
            this.liked = !this.liked
          }
        })
    },
    goToWorkPost () {
      this.$router.push({
        name: "workPost",
        params: {
          workId: this.work.id,
          workName: this.work.get('title')
        }
      })
    }
  },

  components: {
    BottomBar
  }
}



// WEBPACK FOOTER //
// ./src/components/bottom_bar/WorkBottomBar.vue